module.exports = __webpack_public_path__ + "c_static/img/3-2手机京东-购物车.8239708.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/3-2手机京东-购物车.jpg
// module id = k1ba
// module chunks = 33